/**
 * Avatar — initials avatar with deterministic color from id/name.
 *
 * No image support yet (intentional minimalism for the leads MVP).
 * Sizes:  xs (18px) · sm (24px) · md (32px).
 */
import React from "react";

const PALETTE = [
  "#9C5236", // dolce terracotta
  "#3F7D58", // forest
  "#3b82f6",
  "#8b5cf6",
  "#0ea5e9",
  "#14b8a6",
  "#d97706",
  "#be185d",
];

function hash(str) {
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

function initials(name = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const SIZES = {
  xs: { box: "w-[18px] h-[18px] text-[9px]" },
  sm: { box: "w-6 h-6 text-[10px]" },
  md: { box: "w-8 h-8 text-xs" },
};

export default function Avatar({
  name = "",
  id = "",
  size = "sm",
  title,
  className = "",
}) {
  const color = PALETTE[hash(id || name) % PALETTE.length];
  const s = SIZES[size] || SIZES.sm;
  return (
    <span
      title={title || name}
      className={`inline-flex items-center justify-center rounded-full font-medium text-white ${s.box} ${className}`}
      style={{ background: color }}
    >
      {initials(name)}
    </span>
  );
}
